import React from 'react';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated'
import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children, loginPath }) => {
  const isAuthenticated = useIsAuthenticated();

  return isAuthenticated ? children : <Navigate to={loginPath} />;
};

export default RequireAuth;